// Phase 52 VIS-01 — StudioHero
//
// First consumer of the Phase 51 vite-imagetools pipeline (typed barrel
// `studioPictures` / named export `studio01`). Renders a landscape (well,
// portrait-aspect placeholder until real photos land in Phase 52.5) studio
// interior photo above the fold of `Home.tsx`.
//
// LCP contract :
//   - <source type="image/avif"> FIRST (modern browsers descend the list and
//     pick the first they understand → Chrome 85+/Safari 16+ get AVIF)
//   - <source type="image/webp"> SECOND (Safari 14-15.6 + ancient Chrome)
//   - <img> JPEG fallback for the rest + acts as the universal element the
//     browser actually renders.
//
// The `<img>` carries fetchpriority="high" + loading="eager" + decoding="async"
// + explicit width/height to (a) skip lazy-load deferral, (b) prioritise the
// LCP candidate over other early-network requests, (c) reserve layout space
// pre-paint (no CLS).
//
// Refs: phase 52
import { studio01 } from '../../assets/studio'
import { useLanguage } from '../../i18n/LanguageProvider'

export default function StudioHero() {
  const { t } = useLanguage()
  return (
    <picture>
      <source type="image/avif" srcSet={studio01.sources.avif} />
      <source type="image/webp" srcSet={studio01.sources.webp} />
      <img
        src={studio01.img.src}
        width={studio01.img.w}
        height={studio01.img.h}
        alt={t('studio.hero.alt')}
        fetchPriority="high"
        loading="eager"
        decoding="async"
        className="w-full h-auto rounded-[8px] object-cover"
      />
    </picture>
  )
}
